import { API_URL } from '../../helpers/constants';

export const URL_ORDER = `${API_URL}/booking/orders`;
